import React, { useState, useEffect } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, Collapse, Label, Input, Button, Card, CardBody, Spinner, CardHeader, CardFooter, Container } from 'reactstrap';
import Select, { components } from 'react-select';
import { FaChevronRight, FaChevronLeft, FaChevronUp, FaChevronDown, FaSave } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import axios from 'axios';
import uuid from 'react-uuid';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import './ContaminantEvaluation.css';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const ContaminantEvaluation = ({ refreshToken,handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    //const isAddEditItem = localStorage.getItem("isAddEditItem");
    //const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [loading, setLoading] = useState(true);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [contaminantEvaluation, setContaminantEvaluation] = useState({
        Section: 'Contaminant Self Evaluation', SectionName: 'Risk Evaluation', isWizardCompleted: false,
        nitrogen: 'Low', pathogen: 'Low', phosphorous: 'Low', erosion:'Low'
    });
    const [erosionRows, setErosionRows] = useState({
        q1id: 1, q1value: "", q1description: "Other than in vine-rows is there visual evidence of erosion - scars, slumps, rilling, tunnelling, and exposed soil?",
        q2id: 2, q2value: "", q2description: "Has the vineyard soil been contoured?",
        q3id: 3, q3value: "", q3description: "During rainfall does sediment flow to any waterways - ephemeral, intermittent, or perennial?",
        q4id: 4, q4value: "", q4description: "Do any waterways within the vineyard connect to any other waterways?",
        q5id: 5, q5value: "", q5description: "Block developments - do you keep a buffer zone of long sward wider than 2m around the edge of the development?",
        q6id: 6, q6value: "", q6description: "Block developments  - do you sow a cover crop as soon as possible after cultivating?"
    });
    const [nitrogenRows, setNitrogenRows] = useState({
        q1id: 1, q1value: "", q1description: "Do you apply Nitrogen fertilisers in Spring?",
        q11id: 2, q11value: [], q11description: "When do you apply Nitrogen fertilizer in Spring?", q1Visible: false, q11List: [{ label: 'Prior to budburst', value: 'Prior to budburst' }, { label: 'Within 4 weeks from budburst', value: 'Within 4 weeks from budburst' }, { label: '4 weeks after budburst and/or throughout the growing season', value: '4 weeks after budburst and/or throughout the growing season' }],
        q2id: 3, q2value: "", q2description: "Do you apply Nitrogen fertilisers post-harvest?",
        q21id: 4, q21value: "", q21description: "Do you apply Nitrogen fertilisers before or after leaf fall?", q2Visible: false,
        q3id: 5, q3value: "", q3description: "Are you planning any block redevelopments/replanting  or new developments within the next 5 years?",
        q31id: 6, q31value: "", q31description: "Do you intend to apply Nitrogen fertiliser at the time of cultivating or pre-cultivating?",
        q32id: 7, q32value: "", q32description: "Do you intend to apply Nitrogen fertiliser at the time that the vines are planted?",
        q33id: 8, q33value: "", q33description: "Do you apply Nitrogen fertiliser at least 3 weeks after planting?  ", q3Visible: false
});
    const [phosphorousRows, setPhosphorousRows] = useState({
        q1id: 1, q1value: "", q1description: "Do current Olsen P levels exceed, or are at the upper end of the optimum levels on any part of the vineyard?  Optimum levels for Sedimentary and Ash soils is 20-30, Pumice and Peat soils is 25-45.",
        q2id: 2, q2value: "", q2description: "Is there any evidence of erosion on the vineyard and/or on waterway banks?",
        q3id: 3, q3value: "", q3description: "Are there parts of the vineyard that are hilly or steep and/or parts that have been contoured?  Slopes can generate higher rates of runoff and contoured areas often have a thin layer of topsoil risking runoff of sediment from subsoil.",
        q4id: 4, q4value: "", q4description: "Are the dominant soil types poorly drained, clayey, hydrophobic, or slowly permeable? There is a greater chance that these soil types will create higher runoff rates.",
        q5id: 5, q5value: "", q5description: "Do any livestock graze in the vineyard for 4 weeks or longer?"
    });
    const [pathogenRows, setPathogenRows] = useState({
        q1id: 1, q1value: "", q1description: "Do you intend to graze any livestock in the vineyard at any time of the year?",
        q21id: 2, q11value: "", q11description: "Do any livestock have access to any waterways – ephemeral, intermittent, or perennial?", q1Visible: false,
        q22id: 3, q12value: "", q12description: "Are all waterways fenced with either secure temporary, or permanent fencing set back at least 2m from the waterway?",
        q23id: 4, q13value: "", q13description: "Is there a buffer zone of long sward wider than 2m, or a densely planted strip (e.g. Gossamer grass or Carex secta) wider than 0.5m around the waterway?",
        q24id: 5, q14value: "", q14description: "Are all water troughs situated at least 30m from any waterway?"
    });
    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/ContaminantEvaluation/GetContaminantEvaluationDetails/', {
                params: { Id: farmId }
            }
            );
            setContaminantEvaluation({ ...contaminantEvaluation, erosion: response.data.content.erosion, pathogen: response.data.content.pathogen, phosphorous: response.data.content.phosphorous, nitrogen: response.data.content.nitrogen });
            setErosionRows(response.data.content.erosionValues);
            setNitrogenRows(response.data.content.nitrogenValues);
            setPhosphorousRows(response.data.content.phosphorousValues);
            setPathogenRows(response.data.content.pathogenValues);
            if (response.data.content.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.content.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
            setLoading(false);
        }
    }
    const [isErosionOpen, setIsErosionOpen] = useState(true);
    const [isErosionIconUp, setIsErosionIconUp] = useState(false);
    const toggleErosion = () => {
        setIsErosionOpen(!isErosionOpen);
        setIsErosionIconUp(!isErosionIconUp);
    };

    const [isNitrogenOpen, setIsNitrogenOpen] = useState(true);
    const [isNitrogenIconUp, setIsNitrogenIconUp] = useState(false);
    const toggleNitrogen = () => {
        setIsNitrogenOpen(!isNitrogenOpen);
        setIsNitrogenIconUp(!isNitrogenIconUp);
    };

    const [isPhosphorusOpen, setIsPhosphorusOpen] = useState(true);
    const [isPhosphorusIconUp, setIsPhosphorusIconUp] = useState(false);
    const togglesPhosphorus = () => {
        setIsPhosphorusOpen(!isPhosphorusOpen);
        setIsPhosphorusIconUp(!isPhosphorusIconUp);
    };

    const [isPathogensOpen, setIsPathogensOpen] = useState(true);
    const [isPathogensIconUp, setIsPathogensIconUp] = useState(false);
    const togglePathogens = () => {
        setIsPathogensOpen(!isPathogensOpen);
        setIsPathogensIconUp(!isPathogensIconUp);
    };

    const handleErosionValueChange = (item, value) => {
        var count = 0; var count1 = 0; var yesValue = 1; var noValue = 1;
        if (item == 'q1') {
            if (value == 'Yes') {
                ++count;
            }
            if (erosionRows.q2value == 'Yes') {
                ++count;
            }
            if (erosionRows.q3value == 'Yes') {
                ++count;
            }
            if (erosionRows.q4value == 'Yes') {
                ++count;
            }
            if (erosionRows.q5value == 'No') {
                ++count1;
            }
            if (erosionRows.q6value == 'No') {
                ++count1;
            }
        }
        else if (item == 'q2') {
            if (value == 'Yes') {
                ++count;
            }
            if (erosionRows.q1value == 'Yes') {
                ++count;
            }
            if (erosionRows.q3value == 'Yes') {
                ++count;
            }
            if (erosionRows.q4value == 'Yes') {
                ++count;
            }
            if (erosionRows.q5value == 'No') {
                ++count1;
            }
            if (erosionRows.q6value == 'No') {
                ++count1;
            }
        }
        else if (item == 'q3') {
            if (value == 'Yes') {
                ++count;
            }
            if (erosionRows.q2value == 'Yes') {
                ++count;
            }
            if (erosionRows.q1value == 'Yes') {
                ++count;
            }
            if (erosionRows.q4value == 'Yes') {
                ++count;
            }
            if (erosionRows.q5value == 'No') {
                ++count1;
            }
            if (erosionRows.q6value == 'No') {
                ++count1;
            }
        }
        else if (item == 'q4') {
            if (value == 'Yes') {
                ++count;
            }
            if (erosionRows.q2value == 'Yes') {
                ++count;
            }
            if (erosionRows.q3value == 'Yes') {
                ++count;
            }
            if (erosionRows.q1value == 'Yes') {
                ++count;
            }
            if (erosionRows.q5value == 'No') {
                ++count1;
            }
            if (erosionRows.q6value == 'No') {
                ++count1;
            }
        }
        else if (item == 'q5') {
            if (value == 'No') {
                ++count1;
            }
            if (erosionRows.q6value == 'No') {
                ++count1;
            }
            if (erosionRows.q1value == 'Yes') {
                ++count;
            }
            if (erosionRows.q2value == 'Yes') {
                ++count;
            }
            if (erosionRows.q3value == 'Yes') {
                ++count;
            }
            if (erosionRows.q4value == 'Yes') {
                ++count;
            }
        }
        else if (item == 'q6') {
            if (value == 'No') {
                ++count1;
            }
            if (erosionRows.q5value == 'No') {
                ++count1;
            }
            if (erosionRows.q1value == 'Yes') {
                ++count;
            }
            if (erosionRows.q2value == 'Yes') {
                ++count;
            }
            if (erosionRows.q3value == 'Yes') {
                ++count;
            }
            if (erosionRows.q4value == 'Yes') {
                ++count;
            }
        }

        if (count > 1) {
            yesValue = 3;
        }
        else if (count == 1) {
            yesValue = 2;
        }
        if (count1 > 1) {
            noValue = 3;
        }
        else if (count1 == 1) {
            noValue = 2;
        }
        var result = 'Low';
        result = Math.max(yesValue, noValue) == 3 ? 'High' : (Math.max(yesValue, noValue) == 2 ? 'Medium' : 'Low');
        setContaminantEvaluation({ ...contaminantEvaluation, erosion: result });
    };
    //const handleErosionq5q6Change = (item, value) => {
        
    //};
    function findNitrogenq2Value() {
        var q2 = 0;
        if (nitrogenRows.q21value == 'After leaf fall') {
            q2 = 3;
        }
        else if (nitrogenRows.q21value == 'Before leaf fall') {
            q2 = 1;
        }
        return q2;
    }
    function findNitrogenq1Value() {
        var q1 = 0;
        nitrogenRows.q11value.forEach(function (element) {
            if (element.label == '4 weeks after budburst and/or throughout the growing season') {
                if (q1 == 0)
                    q1 = 1;
            }
            else if (element.label == 'Prior to budburst' || element.label == 'Within 4 weeks from budburst') {
                q1 = 3;
            }
        });
        return q1;
    }
    function findNitrogenq3Value() {
        var q3 = 0;
        if (nitrogenRows.q31value == "No") {
            if (nitrogenRows.q32value == 'Yes')
                q3 = 2;
            else
                q3 = 1;
        }
        else if (nitrogenRows.q31value == "Yes") {
            if (nitrogenRows.q32value == 'Yes')
                q3 = 3;
            else
                q3 = 2;
        }
        else {
            q3 = 1;
        }
        return q3;
    }
    function findNitrogenq33Value() {
        var q33 = 0;
        if (nitrogenRows.q33value == "No") {
            q33 = 3;
        }
        else if (nitrogenRows.q33value == "Yes") {
            q33 = 1;
        }
        return q33;
    }
    const handleNitrogenValueChange = (item, value) => {
        var valueArr = [];
        var q1 = 0; var q2 = 0; var q3 = 0; var q33 = 0;
        var count = 0; var count1 = 0; var yesValue = 1; var noValue = 1;

        if (item == 'q1') {
            if (value == "No") {
                q1 = 1;
                valueArr.push(q1);
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq3Value());
                valueArr.push(findNitrogenq33Value());
            }
            //setNitrogenRows({ ...nitrogenRows, q11value: [] })
        }
        else if (item == 'q11') {
            value.forEach(function (element) {
                if (element.label == '4 weeks after budburst and/or throughout the growing season') {
                    if (q1 == 0)
                    q1 = 1;
                }
                else if (element.label == 'Prior to budburst' || element.label == 'Within 4 weeks from budburst') {
                    q1 = 3;
                }
            });
            valueArr.push(q1);
            valueArr.push(findNitrogenq2Value());
            valueArr.push(findNitrogenq3Value());
            valueArr.push(findNitrogenq33Value());
        }
        else if (item == 'q2') {
            if (value == "No") {
                q2 = 1;
                valueArr.push(q2);
                valueArr.push(findNitrogenq1Value());                
                valueArr.push(findNitrogenq3Value());
                valueArr.push(findNitrogenq33Value());
            }
            //setNitrogenRows({ ...nitrogenRows, q21value: '' })
        }
        else if (item == 'q21') {
            if (value == "After leaf fall") {
                q2 = 3;
                valueArr.push(q2);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq3Value());
                valueArr.push(findNitrogenq33Value());
            }
            else if (value == "Before leaf fall") {
                q2 = 1;
                valueArr.push(q2);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq3Value());
                valueArr.push(findNitrogenq33Value());
            }
        }
        else if (item == 'q3') {
            if (value == "No") {
                q3 = 1;
                valueArr.push(q3);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq33Value());

                if (erosionRows.q1value == 'Yes') {
                    ++count;
                }
                if (erosionRows.q2value == 'Yes') {
                    ++count;
                }
                if (erosionRows.q3value == 'Yes') {
                    ++count;
                }
                if (erosionRows.q4value == 'Yes') {
                    ++count;
                }
                if (count > 1) {
                    yesValue = 3;
                }
                else if (count == 1) {
                    yesValue = 2;
                }
                if (count1 > 1) {
                    noValue = 3;
                }
                else if (count1 == 1) {
                    noValue = 2;
                }
                var result = 'Low';
                result = Math.max(yesValue, noValue) == 3 ? 'High' : (Math.max(yesValue, noValue) == 2 ? 'Medium' : 'Low');
                setContaminantEvaluation({ ...contaminantEvaluation, nitrogen: findLarget(valueArr), erosion: result });
            }
        }
        else if (item == 'q31') {
            if (value == "No") {
                if (nitrogenRows.q32value == 'Yes') 
                    q3 = 2;
                else
                    q3 = 1;
                valueArr.push(q3);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq33Value());
            }
            else if (value == "Yes") {
                if (nitrogenRows.q32value == 'Yes')
                    q3 = 3;
                else
                    q3 = 2;
                valueArr.push(q3);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq33Value());
            }
        }
        else if (item == 'q32') {
            if (value == "No") {
                if (nitrogenRows.q31value == 'Yes')
                    q3 = 2;
                else
                    q3 = 1;
                valueArr.push(q3);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq33Value());
            }
            else if (value == "Yes") {
                if (nitrogenRows.q31value == 'Yes')
                    q3 = 3;
                else
                    q3 = 2;
                valueArr.push(q3);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq33Value());
            }
        }
        else if (item == 'q33') {
            if (value == "No") {
                q33 = 3;
                valueArr.push(q33);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq3Value());
            }
            else {
                q33 = 1;
                valueArr.push(q33);
                valueArr.push(findNitrogenq1Value());
                valueArr.push(findNitrogenq2Value());
                valueArr.push(findNitrogenq3Value());
            }
        }
        if (item != 'q3' && value != "No") {
            setContaminantEvaluation({ ...contaminantEvaluation, nitrogen: findLarget(valueArr) });
        }
    };
    const handlePhosphorousValueChange = (item,value) => {
        var count = 0;
        if (item == 'q1') {
            if (value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q2value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q3value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q4value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q5value == 'Yes') {
                ++count;
            }
        }
        else if (item == 'q2') {
            if (value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q1value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q3value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q4value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q5value == 'Yes') {
                ++count;
            }
        }
        else if (item == 'q3') {
            if (value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q2value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q1value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q4value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q5value == 'Yes') {
                ++count;
            }
        }
        else if (item == 'q4') {
            if (value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q2value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q3value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q1value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q5value == 'Yes') {
                ++count;
            }
        }
        else if (item == 'q5') {
            if (value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q2value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q3value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q4value == 'Yes') {
                ++count;
            }
            if (phosphorousRows.q1value == 'Yes') {
                ++count;
            }
        }
        if (count > 1) {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'High' });
        }
        else if (count == 1) {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'Medium' });
        }
        else {
            setContaminantEvaluation({ ...contaminantEvaluation, phosphorous: 'Low' });
        }
    };
    function findPathogenq11Value() {
        var value = 0;
        if (pathogenRows.q11value == 'Yes')
            value = 3;
        else if (pathogenRows.q11value == 'No') value = 1;
        return value;
    }
    function findPathogenq12Value() {
        var value = 0;
        if (pathogenRows.q12value == 'Yes')
            value = 1;
        else if (pathogenRows.q12value == 'No') value = 3;
        return value;
    }
    function findPathogenq13Value() {
        var value = 0;
        if (pathogenRows.q13value == 'Yes')
            value = 1;
        else if (pathogenRows.q13value == 'No') value = 3;
        return value;
    }
    function findPathogenq14Value() {
        var value = 0;
        if (pathogenRows.q14value == 'Yes')
            value = 1;
        else if (pathogenRows.q14value == 'No') value = 3;
        return value;
    }

    const handlePathogenValueChange = (item, value) => {
        var result = 'Low'; var q11 = 0; var q12 = 0; var q13 = 0; var q14 = 0;
        var valueArr = [];
        if (item == 'q1') {
            if (value == 'No') {
                result = 'Low';
            }
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: result });
        }
        else {
            if (item == 'q11') {
                if (value == 'No') {
                    q11 = 1;
                } else if (value == 'Yes') {
                    q11 = 3;
                }
                valueArr.push(q11);
                valueArr.push(findPathogenq12Value());
                valueArr.push(findPathogenq13Value());
                valueArr.push(findPathogenq14Value());
            }
            else if (item == 'q12') {
                if (value == 'No') {
                    q12 = 3;
                } else if (value == 'Yes') {
                    q12 = 1;
                }
                valueArr.push(q12);
                valueArr.push(findPathogenq11Value());
                valueArr.push(findPathogenq13Value());
                valueArr.push(findPathogenq14Value());
            }
            else if (item == 'q13') {
                if (value == 'No') {
                    q13 = 3;
                } else if (value == 'Yes') {
                    q13 = 1;
                }
                valueArr.push(q13);
                valueArr.push(findPathogenq11Value());
                valueArr.push(findPathogenq12Value());
                valueArr.push(findPathogenq14Value());
            }
            else if (item == 'q14') {
                if (value == 'No') {
                    q14 = 3;
                } else if (value == 'Yes') {
                    q14 = 1;
                }
                valueArr.push(q14);
                valueArr.push(findPathogenq11Value());
                valueArr.push(findPathogenq12Value());
                valueArr.push(findPathogenq13Value());
            }
            setContaminantEvaluation({ ...contaminantEvaluation, pathogen: findLarget(valueArr) });
        }
        
    };

    const [showsavingErosion, setShowSavingErosion] = useState(true);
    const [showsavingNitrogen, setShowSavingNitrogen] = useState(true);
    const [showsavingPhosphorous, setShowSavingPhosphorous] = useState(true);
    const [showsavingPathogen, setShowSavingPathogen] = useState(true);

    const [savingErosion, setSavingErosion] = useState(false);
    const [savingNitrogen, setSavingNitrogen] = useState(false);
    const [savingPhosphorous, setSavingPhosphorous] = useState(false);
    const [savingPathogen, setSavingPathogen] = useState(false);
    const handleSavingErosion = async (e) => {
        e.preventDefault()
        setSavingErosion(true);
        setShowSavingNitrogen(false);
        setShowSavingPhosphorous(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e,'');
    };
    const handleSavingNitrogen = async (e) => {
        e.preventDefault()
        setSavingNitrogen(true);
        setShowSavingErosion(false);
        setShowSavingPhosphorous(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e, '');
    };
    const handleSavingPhosphorous = async (e) => {
        e.preventDefault()
        setSavingPhosphorous(true);
        setShowSavingErosion(false);
        setShowSavingNitrogen(false);
        setShowSavingPathogen(false);
        saveContaminantEvaluation(e, '');
    };
    const handleSavingPathogen = async (e) => {
        e.preventDefault()
        setSavingPathogen(true);
        setShowSavingErosion(false);
        setShowSavingNitrogen(false);
        setShowSavingPhosphorous(false);
        saveContaminantEvaluation(e, '');
    };

    const handleNextButton = async (e,section,type) => {
        e.preventDefault();
        await saveContaminantEvaluation(e,'Next');
        if (type == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (type == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
    };

    const saveContaminantEvaluation = async (e) => {
        var ContaminantSelfEvaluationHeaderModel = {
            ErosionValues: erosionRows,
            NitrogenValues: nitrogenRows,
            PhosphorousValues: phosphorousRows,
            PathogenValues: pathogenRows,
            Erosion: contaminantEvaluation.erosion,
            Nitrogen: contaminantEvaluation.nitrogen,
            Phosphorous: contaminantEvaluation.phosphorous,
            Pathogen: contaminantEvaluation.pathogen,
        };
        var form = {
            UserId: userId,
            FarmId: farmId,
            ContaminantSelfEvaluationHeader: ContaminantSelfEvaluationHeaderModel
        };
        
        const response = await apiPost(
            '/api/ContaminantEvaluation/Save/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                
            }
        }
    }

    function findLarget(arr) {
        const largest = Math.max(...arr);
        if (largest == 3)
            return 'High';
        else if (largest == 2)
            return 'Medium';
        else
            return 'Low';
    }

    const [savingContaminantEvaluation, setSavingContaminantEvaluation] = useState(false);
    const [savingNext, setSavingNext] = useState(false);
    const [savingBack, setSavingBack] = useState(false);

    const handleContaminantEvaluationDetailSave = async (e, from, section, method) => {
        e.preventDefault();
        if (from == '') {
            setSavingContaminantEvaluation(true);
        }
        else if (from == 'Next') {
            setSavingNext(true);
        }
        else if (from == 'Back') {
            setSavingBack(true);
        }

        await saveContaminantEvaluation(e);
        toast.success("Contaminant Evaluation Details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        if (from == '') {
            setSavingContaminantEvaluation(false);
            refreshToken();
        }
        else if (from == 'Next') {
            setSavingNext(false);
            method(section);
        }
        else if (from == 'Back') {
            setSavingBack(false);
            method(section);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">Risk Evaluation</h3></Col>
                {contaminantEvaluation.isWizardCompleted != true && !loading &&
                    <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                            {
                                /*<Button className="float-end btn-next-page" onClick={(e) => handleNextButton(e, contaminantEvaluation.Section,'handleWizardChanged')}>Next <FaChevronRight /> </Button>*/
                                <>
                                    {savingNext ?
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, 'Next', contaminantEvaluation.Section, handleWizardChanged)}
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Processing
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Processing...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, 'Next', contaminantEvaluation.Section, handleWizardChanged)} >
                                            Next <FaChevronRight />
                                        </Button>
                                    }
                                    {savingContaminantEvaluation ?
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, '', '', null)}
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, '', '', null)} >
                                            Save 
                                        </Button>
                                    }
                                    {savingBack ?
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, 'Back', contaminantEvaluation.Section, handleWizardChangedBack)}
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="8">
                                                    <span>
                                                        {' '}Processing
                                                    </span>
                                                </Col>
                                                <Col sm="4">
                                                    <Spinner size="sm">
                                                        Processing...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button className="float-end btn-next-page" onClick={(e) => handleContaminantEvaluationDetailSave(e, 'Back', contaminantEvaluation.Section, handleWizardChangedBack)} >
                                            Back <FaChevronLeft />
                                        </Button>
                                    }
                                </>
                                }
                            </>
                        }
                        {(roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager') && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(contaminantEvaluation.Section)}>Next <FaChevronRight /> </Button>
                            <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(contaminantEvaluation.Section)}>Back <FaChevronLeft /> </Button>
                            </>
                        }
                        
                    </Col>
                }
            </Row>
            {loading ? <SpinnerContainer /> : <>
                <Row>
                    <Col>
                        <p><b>Use this tool to identify and evaluate risks to the environment from the viticultural activities and/or the biophysical features of the vineyard.</b></p>
                        {/*<p><u>Definitions of waterways:</u></p>*/}
                        {/*• Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.*/}
                        {/*<br/>*/}
                        {/*• Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.*/}
                        {/*<br />*/}
                        {/*• Perennial – a waterway that is full or continues to flow throughout the year for all or most years.<br />*/}
                        {/*• Groundwater - Groundwater is the water present beneath Earth's surface.*/}
                    </Col>
                </Row>
                <Row xs="2">
                    <Col>
                        <Container fluid className="d-flex flex-column h-100">
                            <Card className="my-4 card-header-outline flex-grow-1 d-flex flex-column card-outline-Square" style={{ maxHeight: "100vw" }}>
                                <CardHeader className="card-square-header" onClick={toggleNitrogen}>
                                <Row>
                                    <Col>
                                        <h5>Nitrogen</h5>
                                    </Col>
                                </Row>
                            </CardHeader>                            
                                <CardBody >
                                    <Row>
                                        <Col>
                                            <label>
                                                <b>The timing of nitrogen fertiliser applications is important to ensure there is no or minimal damage to the environment. Nitrogen is at risk of leaching through permeable soils and from runoff from compacted or less impermeable soils. Nitrogen applications must be carried out when the vines are at a growth stage which will allow the plant to take up nitrogen and at application rates which are compatible with the vines’ capacity to use all the nitrogen applied.</b> 
                                            </label>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <tbody className="text-left">
                                                    <tr key="row11">
                                                        <td style={{ display: "none" }}>{nitrogenRows.q1id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    1*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {nitrogenRows.q1description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={nitrogenRows.q1value} onChange={(e) => { if (e.target.value == 'Yes') { setNitrogenRows({ ...nitrogenRows, q1value: e.target.value, q1Visible: true, q11value: [] }); handleNitrogenValueChange('q1', e.target.value); } else { setNitrogenRows({ ...nitrogenRows, q1value: e.target.value, q1Visible: false, q11value: [] }); handleNitrogenValueChange('q1', e.target.value); } }} name="q1value" id="q1value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    {nitrogenRows.q1Visible && 
                                                        <tr key="row12">
                                                            <td style={{ display: "none" }}>{nitrogenRows.q11id}</td>
                                                            {/*<td style={{ width: "5%" }}>*/}
                                                            {/*    1.1*/}
                                                            {/*</td>*/}
                                                            <td style={{ width: "65%" }}>
                                                                {nitrogenRows.q11description}
                                                            </td>
                                                            <td style={{ width: "30%" }}>
                                                                {nitrogenRows.q1Visible &&
                                                                    <>
                                                                    <Select className="dropdown" placeholder="Select Option" value={nitrogenRows.q11value} options={nitrogenRows.q11List}
                                                                        onChange={(e) => { setNitrogenRows({ ...nitrogenRows, q11value: e }); handleNitrogenValueChange('q11', e); }}
                                                                        isMulti isClearable
                                                                        closeMenuOnSelect={false}
                                                                        styles={{
                                                                            valueContainer: (base) => ({
                                                                                ...base,
                                                                                flexWrap: 'wrap',
                                                                                /*maxHeight: '60px',*/
                                                                                overflowY: 'auto'
                                                                            }),
                                                                            multiValue: (base) => ({
                                                                                ...base,
                                                                                whiteSpace: 'normal',
                                                                            }),
                                                                            multiValueLabel: (base) => ({
                                                                                ...base,
                                                                                whiteSpace: 'normal',
                                                                                wordBreak: 'break-word',
                                                                            }),
                                                                        }}
                                                                    />
                                                                    </>
                                                                }
                                                            </td>
                                                        </tr>    
                                                    }
                                                    <tr key="row13">
                                                        <td style={{ display: "none" }}>{nitrogenRows.q2id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    2*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {nitrogenRows.q2description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={nitrogenRows.q2value} onChange={(e) => { if (e.target.value == 'Yes') { setNitrogenRows({ ...nitrogenRows, q2value: e.target.value, q2Visible: true, q21value: '' }); handleNitrogenValueChange('q2', e.target.value); } else { setNitrogenRows({ ...nitrogenRows, q2value: e.target.value, q2Visible: false, q21value: '' }); handleNitrogenValueChange('q2', e.target.value); } }} name="q2value" id="q2value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    {nitrogenRows.q2Visible &&
                                                        <tr key="row14">
                                                            <td style={{ display: "none" }}>{nitrogenRows.q21id}</td>
                                                            {/*<td style={{ width: "5%" }}>*/}
                                                            {/*    2.1*/}
                                                            {/*</td>*/}
                                                            <td style={{ width: "65%" }}>
                                                                {nitrogenRows.q21description}
                                                            </td>
                                                            <td style={{ width: "30%" }}>
                                                                {nitrogenRows.q2Visible &&
                                                                    <Input type="select" value={nitrogenRows.q21value} onChange={(e) => { setNitrogenRows({ ...nitrogenRows, q21value: e.target.value }); handleNitrogenValueChange('q21', e.target.value); }} name="q21value" id="q21value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='After leaf fall'>After leaf fall</option>
                                                                        <option key={uuid()} value='Before leaf fall'>Before leaf fall</option>
                                                                    </Input>
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                    
                                                    <tr key="row141">
                                                        <td colSpan="3"><label><i>Nitrogen is very mobile in soil and is readily lost if there are no plants to take it up. Cultivating soil releases nitrogen naturally. Newly planted vines take 3 weeks to ‘wake up’ and use the nutrients around them, so it is important to time applications of nitrogen fertiliser with the vines ability to take up nutrients.</i></label></td>
                                                    </tr>
                                                    <tr key="row15">
                                                        <td style={{ display: "none" }}>{nitrogenRows.q3id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    3*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {nitrogenRows.q3description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={nitrogenRows.q3value} onChange={(e) => {
                                                                if (e.target.value == 'Yes') { setNitrogenRows({ ...nitrogenRows, q3value: e.target.value, q3Visible: true, q31value: '', q32value: '', q33value: '' }); handleNitrogenValueChange('q3', e.target.value); } if (e.target.value == 'No') {
                                                                    setNitrogenRows({ ...nitrogenRows, q3value: e.target.value, q3Visible: false, q31value: '', q32value: '', q33value: '' }); 
                                                                    setErosionRows({ ...erosionRows, q5value: '', q6value: '' }); handleNitrogenValueChange('q3', e.target.value);
                                                                } else { setNitrogenRows({ ...nitrogenRows, q3value: e.target.value, q3Visible: false, q31value: '', q32value: '', q33value: '' }); handleNitrogenValueChange('q3', e.target.value); }
                                                            }} name="q3value" id="q3value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    {nitrogenRows.q3Visible &&
                                                        <>
                                                            <tr key="row16">
                                                                <td style={{ display: "none" }}>{nitrogenRows.q31id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    3.1*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {nitrogenRows.q31description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {nitrogenRows.q3Visible &&
                                                                        <Input type="select" value={nitrogenRows.q31value} onChange={(e) => { setNitrogenRows({ ...nitrogenRows, q31value: e.target.value }); handleNitrogenValueChange('q31', e.target.value); }} name="q31value" id="q31value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr key="row17">
                                                                <td style={{ display: "none" }}>{nitrogenRows.q32id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    3.2*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {nitrogenRows.q32description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {nitrogenRows.q3Visible &&
                                                                        <Input type="select" value={nitrogenRows.q32value} onChange={(e) => { setNitrogenRows({ ...nitrogenRows, q32value: e.target.value }); handleNitrogenValueChange('q32', e.target.value); }} name="q32value" id="q32value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr key="row171">
                                                                <td colSpan="3"><label><i>Evaluation:  If yes to any of the above questions, there is at least a medium risk of nitrogen contamination of waterways and/or groundwater.  If yes to more than one question, there is a likely high risk of nitrogen contamination of waterways and/or groundwater.</i></label></td>
                                                            </tr>
                                                            <tr key="row18">
                                                                <td style={{ display: "none" }}>{nitrogenRows.q33id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    3.3*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {nitrogenRows.q33description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {nitrogenRows.q3Visible &&
                                                                        <Input type="select" value={nitrogenRows.q33value} onChange={(e) => { setNitrogenRows({ ...nitrogenRows, q33value: e.target.value }); handleNitrogenValueChange('q33', e.target.value); }} name="q33value" id="q33value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </>    
                                                    }
                                                    
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>                               
                                <CardFooter className="mt-auto card-square-footer">
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm="9">
                                                <span>
                                                   <b>
                                                            Rating&nbsp;&nbsp;&nbsp;&nbsp;<b><span class="high-rating" style={{ color: contaminantEvaluation.nitrogen == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.nitrogen == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.nitrogen == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.nitrogen}</span></b>
                                                    </b>
                                                </span>
                                            </Col>
                                            <Col sm="3">
                                                    
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardFooter>
                            </Card>
                        </Container>
                    </Col>
                    <Col>
                        <Container fluid className="d-flex flex-column h-100">
                            <Card className="my-4 card-header-outline flex-grow-1 d-flex flex-column card-outline-Square" style={{  maxHeight: "100vw" }}>
                                <CardHeader className="card-square-header" onClick={toggleErosion}>
                                <Row>
                                    <Col>
                                        <h5>Sediment</h5>
                                    </Col>
                                </Row>
                            </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <label>
                                                <b>Most vineyards have bare or cultivated soil under-vine which exposes the soil to the elements and increases the risk of runoff. Sediment which runs off the vineyard can contaminate waterways and impact freshwater quality and freshwater ecosystems. Phosphate binds to sediment, which if it reaches a waterway can lead to problematic algal growth and harm waterway health. Erosion can contribute large quantities of sediment to the wider environment.</b>
                                            </label>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <tbody className="text-left">
                                                    <tr key="row41">
                                                        <td style={{ display: "none" }}>{erosionRows.q1id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    1*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {erosionRows.q1description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={erosionRows.q1value} onChange={(e) => { setErosionRows({ ...erosionRows, q1value: e.target.value }); handleErosionValueChange('q1', e.target.value); }} name="qe1value" id="qe1value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row42">
                                                        <td style={{ display: "none" }}>{erosionRows.q2id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    2*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {erosionRows.q2description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={erosionRows.q2value} onChange={(e) => { setErosionRows({ ...erosionRows, q2value: e.target.value }); handleErosionValueChange('q2', e.target.value); }} name="qe2value" id="qe2value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row43">
                                                        <td style={{ display: "none" }}>{erosionRows.q3id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    3*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {erosionRows.q3description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={erosionRows.q3value} onChange={(e) => { setErosionRows({ ...erosionRows, q3value: e.target.value }); handleErosionValueChange('q3', e.target.value); }} name="qe3value" id="qe3value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row44">
                                                        <td style={{ display: "none" }}>{erosionRows.q4id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    4*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {erosionRows.q4description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={erosionRows.q4value} onChange={(e) => { setErosionRows({ ...erosionRows, q4value: e.target.value }); handleErosionValueChange('q4', e.target.value); }} name="qe4value" id="qe4value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row441">
                                                        <td colSpan="3"><label><i>Evaluation: If you have answered Yes to any of the above questions, there is at least a medium risk of sediment contamination of freshwater. If you have answered Yes to more than one question, there is a likely high risk of sediment contamination of freshwater</i></label></td>
                                                    </tr>
                                                    {nitrogenRows.q3value != 'No' &&
                                                        <>
                                                            <tr key="row45">
                                                                <td style={{ display: "none" }}>{erosionRows.q5id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    5*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {erosionRows.q5description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    <Input type="select" value={erosionRows.q5value} onChange={(e) => { setErosionRows({ ...erosionRows, q5value: e.target.value }); handleErosionValueChange('q5', e.target.value); }} name="qe5value" id="qe5value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                            </tr>
                                                            <tr key="row46">
                                                                <td style={{ display: "none" }}>{erosionRows.q6id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    6*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {erosionRows.q6description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    <Input type="select" value={erosionRows.q6value} onChange={(e) => { setErosionRows({ ...erosionRows, q6value: e.target.value }); handleErosionValueChange('q6', e.target.value); }} name="qe6value" id="qe6value">
                                                                        <option key={uuid()} value=''></option>
                                                                        <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                    </Input>
                                                                </td>
                                                        </tr>
                                                            <tr key="row461">
                                                            <td colSpan="3"><label><i>Evaluation: If you answered No to any of the above questions, there is at least a medium risk of sediment contamination of freshwater. If you answered No to more than one question, there is likely to be a high risk of sediment contamination of freshwater.</i></label></td>
                                                            </tr>
                                                        </>
                                                    }
                                                    
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <br />
                                </CardBody>
                                <CardFooter className="mt-auto card-square-footer">
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm="9">
                                                 <span>
                                                   <b>
                                                            Rating&nbsp;&nbsp;&nbsp;&nbsp;<b><span class="high-rating" style={{ color: contaminantEvaluation.erosion == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.erosion == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.erosion == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.erosion}</span></b>
                                                    </b>
                                                </span>
                                            </Col>
                                            <Col sm="3">
                                                    
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardFooter>
                            </Card>
                        </Container>
                    </Col>
                </Row>
              
                <Row xs="2">
                    <Col>
                        <Container fluid className="d-flex flex-column h-100">
                            <Card className="my-4 card-header-outline flex-grow-1 d-flex flex-column card-outline-Square" style={{  maxHeight: "100vw" }}>
                                <CardHeader className="card-square-header" onClick={togglesPhosphorus}>
                                <Row>
                                    <Col sm="12">
                                        <h5>Phosphorus</h5>
                                    </Col>
                                </Row>
                            </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <label>
                                                <b>Phosphorus can be found in phosphate fertilisers and in animal dung. Phosphorus chemically binds to soil particles. Any wind-borne soil particles, sediment or animal dung runoff from your property are likely to contain phosphorus.</b>
                                            </label>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <tbody className="text-left">
                                                    <tr key="row31">
                                                        <td style={{ display: "none" }}>{phosphorousRows.q1id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    1*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {phosphorousRows.q1description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={phosphorousRows.q1value} onChange={(e) => { setPhosphorousRows({ ...phosphorousRows, q1value: e.target.value }); handlePhosphorousValueChange('q1', e.target.value); }} name="qph1value" id="qph1value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row32">
                                                        <td style={{ display: "none" }}>{phosphorousRows.q2id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    2*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {phosphorousRows.q2description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={phosphorousRows.q2value} onChange={(e) => { setPhosphorousRows({ ...phosphorousRows, q2value: e.target.value }); handlePhosphorousValueChange('q2', e.target.value); }} name="qph2value" id="qph2value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row33">
                                                        <td style={{ display: "none" }}>{phosphorousRows.q3id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    3*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {phosphorousRows.q3description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={phosphorousRows.q3value} onChange={(e) => { setPhosphorousRows({ ...phosphorousRows, q3value: e.target.value }); handlePhosphorousValueChange('q3', e.target.value); }} name="qph3value" id="qph3value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row34">
                                                        <td style={{ display: "none" }}>{phosphorousRows.q4id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    4*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {phosphorousRows.q4description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={phosphorousRows.q4value} onChange={(e) => { setPhosphorousRows({ ...phosphorousRows, q4value: e.target.value }); handlePhosphorousValueChange('q4', e.target.value); }} name="qph4value" id="qph4value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    <tr key="row35">
                                                        <td style={{ display: "none" }}>{phosphorousRows.q5id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    5*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {phosphorousRows.q5description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={phosphorousRows.q5value} onChange={(e) => { setPhosphorousRows({ ...phosphorousRows, q5value: e.target.value }); handlePhosphorousValueChange('q5', e.target.value); }} name="qph5value" id="qph5value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter className="mt-auto card-square-footer">
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col sm="9">
                                                    <span>
                                                        <b>
                                                            Rating&nbsp;&nbsp;&nbsp;&nbsp;<b><span class="high-rating" style={{ color: contaminantEvaluation.phosphorous == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.phosphorous == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.phosphorous == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.phosphorous}</span></b>
                                                        </b>
                                                    </span>
                                                </Col>
                                                <Col sm="3">
                                                    
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Container>
                    </Col>
                    <Col>
                        <Container fluid className="d-flex flex-column h-100">
                            <Card className="my-4 card-header-outline flex-grow-1 d-flex flex-column card-outline-Square" style={{  maxHeight: "100vw" }}>
                                <CardHeader className="card-square-header" onClick={togglePathogens}>
                                <Row>
                                    <Col sm="12">
                                        <h5>Pathogens - Faecal bacteria contamination risk to freshwater</h5>
                                    </Col>
                                </Row>
                            </CardHeader>
                                <CardBody>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <Row>
                                        <Col>
                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                <tbody className="text-left">
                                                    <tr key="row21">
                                                        <td style={{ display: "none" }}>{pathogenRows.q1id}</td>
                                                        {/*<td style={{ width: "5%" }}>*/}
                                                        {/*    1*/}
                                                        {/*</td>*/}
                                                        <td style={{ width: "65%" }}>
                                                            {pathogenRows.q1description}
                                                        </td>
                                                        <td style={{ width: "30%" }}>
                                                            <Input type="select" value={pathogenRows.q1value} onChange={(e) => { if (e.target.value == 'Yes') { setPathogenRows({ ...pathogenRows, q1value: e.target.value, q1Visible: true, q11value: '', q12value: '', q13value: '', q14value: '' }); handlePathogenValueChange('q1', e.target.value); } else { setPathogenRows({ ...pathogenRows, q1value: e.target.value, q1Visible: false, q11value: '', q12value: '', q13value: '', q14value: '' }); handlePathogenValueChange('q1', e.target.value); } }} name="pq1value" id="pq1value">
                                                                <option key={uuid()} value=''></option>
                                                                <option key={uuid()} value='Yes'>Yes</option>
                                                                <option key={uuid()} value='No'>No</option>
                                                            </Input>
                                                        </td>
                                                    </tr>
                                                    {pathogenRows.q1Visible &&
                                                        <>
                                                            <tr key="row22">
                                                                <td style={{ display: "none" }}>{pathogenRows.q11id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    1.1*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {pathogenRows.q11description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {pathogenRows.q1Visible &&
                                                                        <Input type="select" value={pathogenRows.q11value} onChange={(e) => { setPathogenRows({ ...pathogenRows, q11value: e.target.value }); handlePathogenValueChange('q11', e.target.value); }} name="pq11value" id="pq11value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr key="row23">
                                                                <td style={{ display: "none" }}>{pathogenRows.q12id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    1.2*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {pathogenRows.q12description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {pathogenRows.q1Visible &&
                                                                        <Input type="select" value={pathogenRows.q12value} onChange={(e) => { setPathogenRows({ ...pathogenRows, q12value: e.target.value }); handlePathogenValueChange('q12', e.target.value); }} name="pq12value" id="pq12value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                        <option key={uuid()} value='No'>No</option>
                                                                        <option key={uuid()} value='N/A'>N/A</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr key="row24">
                                                                <td style={{ display: "none" }}>{pathogenRows.q13id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    1.3*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {pathogenRows.q13description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {pathogenRows.q1Visible &&
                                                                        <Input type="select" value={pathogenRows.q13value} onChange={(e) => { setPathogenRows({ ...pathogenRows, q13value: e.target.value }); handlePathogenValueChange('q13', e.target.value); }} name="pq13value" id="pq13value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                            <option key={uuid()} value='N/A'>N/A</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr key="row25">
                                                                <td style={{ display: "none" }}>{pathogenRows.q14id}</td>
                                                                {/*<td style={{ width: "5%" }}>*/}
                                                                {/*    1.4*/}
                                                                {/*</td>*/}
                                                                <td style={{ width: "65%" }}>
                                                                    {pathogenRows.q14description}
                                                                </td>
                                                                <td style={{ width: "30%" }}>
                                                                    {pathogenRows.q1Visible &&
                                                                        <Input type="select" value={pathogenRows.q14value} onChange={(e) => { setPathogenRows({ ...pathogenRows, q14value: e.target.value }); handlePathogenValueChange('q14', e.target.value); }} name="pq14value" id="pq14value">
                                                                            <option key={uuid()} value=''></option>
                                                                            <option key={uuid()} value='Yes'>Yes</option>
                                                                            <option key={uuid()} value='No'>No</option>
                                                                        </Input>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </>    
                                                    }
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                    <br />
                                    <br />
                                    <br />
                                    
                                </CardBody>
                                <CardFooter className="mt-auto card-square-footer">
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col sm="9">
                                                    <span>
                                                        <b>
                                                            Rating&nbsp;&nbsp;&nbsp;&nbsp;<b><span class="high-rating" style={{ color: contaminantEvaluation.pathogen == 'High' ? 'rgb(224, 0, 0)' : (contaminantEvaluation.pathogen == 'Medium' ? 'rgb(255, 134, 3)' : (contaminantEvaluation.pathogen == 'Low' ? 'rgb(0, 188, 18)' : '')) }}>{contaminantEvaluation.pathogen}</span></b>
                                                        </b>
                                                    </span>
                                                </Col>
                                                <Col sm="3">
                                                    
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Container>
                    </Col>
                </Row>
            </>
            }
        </div>
    )
}

export default ContaminantEvaluation;